import { ReferentielEnum } from "src/app/utils/enums/referentiel-enum";
import { Referentiel } from "src/app/utils/interfaces/new/referentiel.interface";

export class AldReferentiel {
  static sort(data: Referentiel[]): Referentiel[] {
    const regexAld = /^\([^0-9]+([0-9]+)\).*/;
    return data.sort((a, b) => {
      // Si pas au bon format envoyé en bas de la liste
      if (!regexAld.test(a.libelle)) {
        return 1;
      }
      if (!regexAld.test(b.libelle)) {
        return -1;
      }
      // Si ok
      const numberA = Number.parseInt(regexAld.exec(a.libelle)[1]);
      const numberB = Number.parseInt(regexAld.exec(b.libelle)[1]);
      if (numberA < numberB) {
        return -1;
      }
      if (numberA > numberB) {
        return 1;
      }
      return 0;
    });
  }
}
